import { UserRole, PermissionAction, UserRoleNameToIdMap } from './roles'
import { RouteNames, type RouteName } from '@/router/config/route-names'

/**
 * 权限配置项类型
 * 格式: 'RouteName:action'
 * 示例: 'Job:show', 'Job:edit'
 */
export type PermissionKey = `${RouteName}:${PermissionAction}`

/**
 * 生成所有路由的所有操作权限
 * @param routes 要生成权限的路由名称数组（可选，不传则生成所有路由的权限）
 * @param actions 要生成的操作权限数组（可选，不传则生成所有操作）
 * @returns 权限数组
 */
function generateAllPermissions(
  routes?: RouteName[],
  actions?: PermissionAction[]
): PermissionKey[] {
  const targetRoutes = routes || Object.values(RouteNames);
  const targetActions = actions || Object.values(PermissionAction);

  const permissions: PermissionKey[] = [];
  targetRoutes.forEach(route => {
    targetActions.forEach(action => {
      permissions.push(`${route}:${action}` as PermissionKey);
    });
  });

  return permissions;
}

/**
 * 角色权限配置
 * Key: 角色ID
 * Value: 该角色拥有的权限列表
 */
export const RolePermissionConfig: Record<UserRole, PermissionKey[]> = {
  [UserRole.SUPER_ADMIN]: generateAllPermissions(),

  [UserRole.BUSINESS_ADMIN]: [
    `${RouteNames.Company}:${PermissionAction.SHOW}`,
    `${RouteNames.Switch}:${PermissionAction.SHOW}`,
  ],

  [UserRole.RECRUITMENT_MANAGER]: [
    `${RouteNames.Company}:${PermissionAction.SHOW}`,
    `${RouteNames.Switch}:${PermissionAction.SHOW}`,
  ],

  [UserRole.RECRUITMENT_SPECIALIST]: [
    `${RouteNames.Company}:${PermissionAction.SHOW}`,
    `${RouteNames.Switch}:${PermissionAction.SHOW}`,
  ],

  [UserRole.INTERVIEWER]: [
    `${RouteNames.Company}:${PermissionAction.SHOW}`,
    `${RouteNames.Switch}:${PermissionAction.SHOW}`,
  ],
  [UserRoleNameToIdMap.ROLE_BUSINESS_ADMIN]: [
    `${RouteNames.Company}:${PermissionAction.SHOW}`,
  ],
  [UserRoleNameToIdMap.ROLE_BUSINESS_USER]: [
    `${RouteNames.Company}:${PermissionAction.SHOW}`,
  ],

  [UserRoleNameToIdMap.ROLE_BUSINESS_OPERATION]: [
    `${RouteNames.Company}:${PermissionAction.SHOW}`,
    `${RouteNames.CompanyAgent}:${PermissionAction.SHOW}`,
    `${RouteNames.Switch}:${PermissionAction.SHOW}`,
  ],

  // 猎头端的角色
  [UserRoleNameToIdMap.ROLE_AGENT_ADMIN]: [
    `${RouteNames.CompanyAgent}:${PermissionAction.SHOW}`,
    // `${RouteNames.CompanyAgent}:${PermissionAction.EDIT}`,

    `${RouteNames.Company}:${PermissionAction.SHOW}`,
  ],
  [UserRoleNameToIdMap.ROLE_AGENT_USER]: [
    `${RouteNames.CompanyAgent}:${PermissionAction.SHOW}`,
    
    `${RouteNames.Company}:${PermissionAction.SHOW}`,
  ],
}
